import React from 'react';
import InvoiceAddress from './InvoiceComponents/InvoiceAddress';
import InvoiceNumber from './InvoiceComponents/InvoiceNumber';
import InvoiceDueDate from './InvoiceComponents/InvoiceDueDate';
import InvoiceHeader from './InvoiceComponents/InvoiceHeader';
import BasicDataTable from '../../DataTables/BasicDataTable';
import Cell from '../../DataTables/DataTableComponents/Cell';

export default function Invoice(props) {
	return (
		<div className="Invoice bg-white md:mx-4 max-w-3xl min-w-80 my-4 p-7 rounded-md shadow border w-50">
			<div className="grid" />
			<div className="justify-self-center">
				<InvoiceHeader />
			</div>
			<div className="grid grid-cols-2">
				<div className="justify-self-start">
					<InvoiceAddress />
				</div>
				<div className="justify-self-end text-right">
					<InvoiceAddress />
				</div>
			</div>
			<div className="grid grid-cols-2">
				<div className="justify-self-start">
					<InvoiceNumber />
				</div>
				<div className="justify-self-end text-right">
					<InvoiceDueDate />
				</div>
			</div>
			<div>
				<BasicDataTable
					data={props.data}
					// endpoint={this.buildEndpoint()}
					columns={[
						{
							displayName: 'Description',
							apiName: 'description',
							alignment: 'left'
						},
						{
							displayName: 'Units',
							apiName: 'units',
							alignment: 'left'
						},
						{
							displayName: 'Cost',
							apiName: 'cost',
							alignment: 'right'
						}
					]}
					rowRenderer={(d) => {
						return (
							<tr key={d.description}>
								<td className="px-3 text-left">
									<Cell value={d.description} />
								</td>
								<td className="px-3 text-left">
									<Cell value={d.units} />
								</td>
								<td className="px-3 text-right">
									<Cell value={d.cost} />
								</td>
							</tr>
						);
					}}
				/>
			</div>
		</div>
	);
}
